{
  "app": {
    "name": "ClairoHealth",
    "tagline": "Les soins à domicile, en toute clarté."
  },
  "common": {
    "cancel": "Annuler",
    "continue": "Continuer",
    "back": "Retour",
    "save": "Enregistrer",
    "close": "Fermer",
    "copy": "Copier",
    "copied": "Copié",
    "retry": "Réessayer",
    "undo": "Annuler l’action",
    "loading": "Chargement…",
    "comingSoon": "Bientôt disponible",
    "search": "Rechercher",
    "new": "Nouveau",
    "optional": "Facultatif",
    "soonShort": "Bientôt"
  },
  "boot": {
    "lines": ["On allume le phare…", "On inspecte le port…", "On prépare votre journée…"],
    "failed": "Impossible de démarrer ClairoHealth. Vérifiez votre connexion et réessayez.",
    "slow": "Encore un instant — on réveille les services. Cela peut prendre quelques secondes."
  },
  "theme": {
    "title": "Apparence",
    "subtitle": "Choisissez l’ambiance qui vous convient. Les changements s’appliquent aussitôt.",
    "button": "Changer de thème",
    "current": "Thème actuel : {{name}}",
    "system": {
      "name": "Système",
      "mood": "Suit votre appareil : Phare le jour, Marée de minuit la nuit."
    },
    "lighthouse": {
      "name": "Phare",
      "mood": "Calme et rassurant. Marine et ambre sur papier chaud."
    },
    "harbour-dawn": {
      "name": "Aube sur le port",
      "mood": "Lumière fraîche du matin. Sarcelle profonde et touches de corail."
    },
    "iceberg-alley": {
      "name": "Allée des icebergs",
      "mood": "Net et aérien. Bleu glacier sur blanc froid."
    },
    "jellybean-row": {
      "name": "Rangée Jellybean",
      "mood": "Ludique et lumineux, comme les maisons colorées de St. John’s."
    },
    "fogbank": {
      "name": "Banc de brume",
      "mood": "Doux et concentré. Ardoise feutrée pour les longues journées."
    },
    "northern-lights": {
      "name": "Aurores boréales",
      "mood": "Riche et immersif. Indigo avec verts et violets d’aurore."
    },
    "midnight-tide": {
      "name": "Marée de minuit",
      "mood": "Vrai mode sombre, doux pour les yeux. Noir marine et ambre."
    },
    "light": "Clair",
    "dark": "Sombre",
    "auto": "Auto"
  },
  "language": {
    "label": "Langue",
    "en": "English",
    "fr": "Français",
    "short": {
      "en": "EN",
      "fr": "FR"
    }
  },
  "auth": {
    "hero": [
      "Des soins qui se rendent à chaque porte.",
      "Horaires, notes et équipes, au même endroit.",
      "Conçu à Terre-Neuve pour les soins à domicile au Canada."
    ],
    "signIn": {
      "title": "Bon retour",
      "subtitle": "Connectez-vous à votre espace ClairoHealth.",
      "email": "Courriel professionnel",
      "password": "Mot de passe",
      "submit": "Se connecter",
      "passkey": "Se connecter avec une clé d’accès",
      "or": "ou",
      "forgot": "Mot de passe oublié?",
      "invited": "Première visite? Utilisez le mot de passe temporaire reçu dans votre courriel d’invitation."
    },
    "newPassword": {
      "title": "Choisissez votre mot de passe",
      "subtitle": "Remplacez votre mot de passe temporaire par un mot de passe connu de vous seul.",
      "password": "Nouveau mot de passe",
      "confirm": "Confirmer le mot de passe",
      "rule": "Au moins 14 caractères. Une courte phrase fonctionne bien.",
      "mismatch": "Les mots de passe ne correspondent pas.",
      "tooShort": "Utilisez au moins 14 caractères.",
      "submit": "Définir le mot de passe et continuer"
    },
    "totp": {
      "title": "Vérification en deux étapes",
      "subtitle": "Entrez le code à 6 chiffres de votre application d’authentification.",
      "submit": "Vérifier"
    },
    "errors": {
      "invalidCredentials": "Ce courriel et ce mot de passe ne correspondent pas. Vérifiez-les et réessayez.",
      "tooManyAttempts": "Trop de tentatives. Attendez quelques minutes, puis réessayez.",
      "codeMismatch": "Ce code n’a pas fonctionné. Les codes changent toutes les 30 secondes — essayez le plus récent.",
      "sessionExpired": "Le délai est écoulé et la connexion a expiré. Veuillez recommencer.",
      "passkeyUnavailable": "Les clés d’accès ne sont pas offertes sur cet appareil ou ce navigateur.",
      "passwordPolicy": "Ce mot de passe ne respecte pas les exigences.",
      "generic": "Un problème est survenu pendant la connexion. Veuillez réessayer.",
      "locked": "Votre compte est verrouillé après trop de tentatives de connexion. Demandez à votre administrateur de le déverrouiller.",
      "resetRequired": "Vous devez définir un nouveau mot de passe. Un code vous a été envoyé par courriel.",
      "breached": "Ce mot de passe figure dans une fuite de données. Veuillez en choisir un autre."
    },
    "signedOut": "Vous êtes déconnecté.",
    "preview": {
      "visitTitle": "Margaret O.",
      "visitBody": "9 h · Visite terminée",
      "noteTitle": "Note de visite IA",
      "noteBody": "Rédigée en 4 s · prête à réviser",
      "teamTitle": "Équipe Avalon",
      "teamBody": "12 intervenants en service"
    },
    "forgot": {
      "title": "Réinitialiser votre mot de passe",
      "subtitle": "Nous vous enverrons par courriel un code pour définir un nouveau mot de passe.",
      "send": "M’envoyer un code",
      "back": "Retour à la connexion"
    },
    "reset": {
      "title": "Définir un nouveau mot de passe",
      "subtitle": "Entrez le code envoyé à {{email}}, puis choisissez un nouveau mot de passe.",
      "code": "Code reçu par courriel",
      "resend": "Envoyer un nouveau code",
      "resent": "Nous avons envoyé un nouveau code à {{email}}.",
      "submit": "Enregistrer le mot de passe",
      "done": "Mot de passe mis à jour. Connectez-vous avec votre nouveau mot de passe."
    },
    "noAccess": "Ce compte n’a pas encore accès à ClairoHealth. Demandez une invitation à votre administrateur.",
    "welcome": "Bon retour, {{name}}",
    "codeExpired": "Le délai était un peu trop long; nous avons recommencé pour votre sécurité. Reconnectez-vous."
  },
  "mfa": {
    "setup": {
      "title": "Protégez votre compte",
      "reasonPlatform": "Les comptes du personnel ClairoHealth utilisent toujours la vérification en deux étapes.",
      "reasonOrganization": "Votre organisation exige la vérification en deux étapes.",
      "step1": "Balayez ce code avec une application d’authentification comme Google Authenticator, Microsoft Authenticator ou 1Password.",
      "step2": "Entrez le code à 6 chiffres affiché par l’application.",
      "manualKey": "Impossible de balayer? Entrez plutôt cette clé",
      "verify": "Activer la vérification en deux étapes",
      "verifying": "Vérification de votre code…",
      "success": "La vérification en deux étapes est activée. Tout est prêt.",
      "preparing": "Préparation d’un code sécurisé…"
    },
    "banner": {
      "title": "La vérification en deux étapes est requise",
      "body_one": "Activez-la d’ici {{count}} jour pour conserver votre accès.",
      "body_other": "Activez-la d’ici {{count}} jours pour conserver votre accès.",
      "action": "L’activer maintenant"
    },
    "passkey": {
      "title": "Ajouter une clé d’accès",
      "body": "Connectez-vous avec Face ID, Touch ID ou Windows Hello — plus rapide et à l’abri de l’hameçonnage.",
      "action": "Ajouter une clé d’accès",
      "adding": "En attente de votre appareil…",
      "added": "Clé d’accès ajoutée. La prochaine fois, utilisez simplement votre visage ou votre empreinte."
    }
  },
  "shell": {
    "skip": "Passer au contenu",
    "nav": {
      "label": "Principal",
      "home": "Accueil",
      "organization": "Organisation",
      "schedule": "Horaire",
      "clients": "Clients",
      "caregivers": "Intervenants",
      "appearance": "Apparence",
      "people": "Personnes"
    },
    "collapse": "Réduire la barre latérale",
    "expand": "Agrandir la barre latérale",
    "orgSwitcher": {
      "label": "Organisation",
      "title": "Changer d’organisation",
      "none": "Aucune organisation",
      "platform": "Plateforme"
    },
    "palette": {
      "open": "Rechercher ou aller à…",
      "placeholder": "Tapez une commande ou une recherche…",
      "empty": "Aucun résultat.",
      "navigate": "Aller à",
      "appearance": "Apparence",
      "language": "Langue",
      "account": "Compte"
    },
    "user": {
      "menu": "Menu du compte",
      "security": "Sécurité",
      "signOut": "Se déconnecter"
    }
  },
  "home": {
    "greeting": {
      "morning": "Bonjour, {{name}}",
      "afternoon": "Bon après-midi, {{name}}",
      "evening": "Bonsoir, {{name}}"
    },
    "today": "{{date}} · {{zone}}",
    "stats": {
      "orgUnits": "Unités",
      "branches": "Succursales",
      "role": "Votre rôle",
      "security": "Sécurité du compte",
      "mfaOn": "2 étapes : activée",
      "mfaOff": "2 étapes : désactivée"
    },
    "checklist": {
      "title": "Pour bien démarrer",
      "progress": "{{done}} sur {{total}} terminées",
      "mfa": "Activer la vérification en deux étapes",
      "passkey": "Ajouter une clé d’accès pour vous connecter d’un geste",
      "theme": "Personnalisez : choisissez un thème",
      "invite": "Inviter votre équipe",
      "clients": "Ajouter vos premiers clients"
    },
    "orgCard": {
      "title": "Votre organisation",
      "manage": "Gérer"
    },
    "platform": {
      "title": "Console de la plateforme",
      "body": "Vous êtes connecté en tant que membre du personnel ClairoHealth, sans agence. L’intégration des agences arrivera ici."
    }
  },
  "org": {
    "title": "Organisation",
    "subtitle": "Régions, succursales et équipes. L’accès descend dans l’arbre et s’arrête aux dépositaires.",
    "add": "Ajouter une unité",
    "empty": "Rien ici pour l’instant.",
    "custodianBadge": "Dépositaire",
    "dialog": {
      "title": "Ajouter une unité",
      "name": "Nom",
      "namePlaceholder": "p. ex. Succursale de Gander",
      "type": "Type",
      "parent": "À l’intérieur de",
      "province": "Province",
      "custodian": "Dépositaire distinct des renseignements sur la santé",
      "custodianHint": "Sa propre frontière de confidentialité : les organisations parentes ne verront pas ses dossiers.",
      "submit": "Ajouter"
    },
    "types": {
      "agency": "Agence",
      "region": "Région",
      "branch": "Succursale",
      "team": "Équipe",
      "franchisor": "Franchiseur",
      "franchisee": "Franchisé",
      "household": "Ménage"
    },
    "toast": {
      "creating": "Ajout de {{name}}…",
      "created": "{{name}} ajouté",
      "createdBody": "Prêt pour les personnes et les paramètres."
    }
  },
  "roles": {
    "owner": "Propriétaire",
    "admin": "Administrateur",
    "coordinator": "Coordonnateur",
    "care_manager": "Gestionnaire de soins",
    "billing": "Facturation",
    "caregiver": "Intervenant",
    "platform_admin": "Admin de la plateforme"
  },
  "errors": {
    "unauthenticated": "Votre session a pris fin. Veuillez vous reconnecter.",
    "forbidden": "Vous n’avez pas l’accès requis pour faire cela.",
    "not_found": "Introuvable.",
    "conflict": "Cet élément existe déjà.",
    "bad_request": "Certains renseignements sont à revoir.",
    "mfa_enrollment_required": "Activez la vérification en deux étapes pour continuer.",
    "internal": "Un problème est survenu de notre côté. Nous nous en occupons.",
    "network": "Impossible de joindre ClairoHealth. Vérifiez votre connexion.",
    "copyReference": "Copier la référence",
    "referenceCopied": "Référence copiée",
    "reference": "Référence {{id}}",
    "loadFailed": {
      "title": "Impossible de charger votre espace",
      "body": "Vérifiez votre connexion et réessayez. Votre session est toujours active."
    }
  },
  "notFound": {
    "title": "Perdu en mer",
    "body": "Cette page a dérivé. Ramenons-vous au port.",
    "home": "Retour à l’accueil"
  },
  "session": {
    "idle": {
      "title": "Toujours là?",
      "body": "Pour votre sécurité, vous serez déconnecté dans {{seconds}} secondes.",
      "stay": "Rester connecté",
      "signedOut": "Vous avez été déconnecté après {{minutes}} minutes d’inactivité."
    }
  },
  "people": {
    "title": "Personnes",
    "subtitle": "Toutes les personnes ayant accès à cette organisation, et la sécurité de leur compte.",
    "empty": "Personne pour l’instant.",
    "you": "Vous",
    "staff": "Personnel ClairoHealth",
    "columns": {
      "person": "Personne",
      "access": "Accès",
      "security": "2 étapes",
      "account": "Compte"
    },
    "states": {
      "active": "Actif",
      "invited": "Invité",
      "reset_required": "Doit réinitialiser son mot de passe",
      "locked": "Verrouillé",
      "unknown": "Inconnu"
    },
    "failedSignIns_one": "{{count}} tentative échouée",
    "failedSignIns_other": "{{count}} tentatives échouées",
    "mfaOn": "Activée",
    "mfaOff": "Désactivée",
    "actions": {
      "menu": "Actions pour {{name}}",
      "unlock": "Déverrouiller et réinitialiser le mot de passe",
      "signOut": "Déconnecter partout",
      "remove": "Retirer de l’organisation"
    },
    "remove": {
      "title": "Retirer {{name}}?",
      "body": "La personne perd immédiatement l’accès à cette organisation. Son accès aux autres organisations n’est pas touché.",
      "confirm": "Retirer"
    },
    "toast": {
      "unlocking": "Déverrouillage de {{name}}…",
      "unlocked": "{{name}} déverrouillé",
      "unlockedBody": "Nous lui avons envoyé un code pour définir un nouveau mot de passe.",
      "signingOut": "Déconnexion de {{name}}…",
      "signedOut": "{{name}} est déconnecté partout",
      "removing": "Retrait de {{name}}…",
      "removed": "{{name}} retiré de cette organisation"
    }
  }
}
